<template>
  <div>
    <my-asidebar v-bind:active-tab="'reports'"> </my-asidebar>
    <section class="dashboard-area p-3">
      <top-bar></top-bar>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-box" v-if="agencyReportData != null">
              <div class="form-title-wrap">
                <div class="d-flex align-items-center justify-content-between">
                  <h3 class="title">Sail Booking Report</h3>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <button class="theme-btn" type="button" @click="excelFileDownload()">Excel çıktısı al</button>
                </div>
              </div>

              <v-app>
                <v-data-table
                    :headers="headers"
                    :items="agencyReportData"
                    :items-per-page="100"
                    class="elevation-1"
                    :search="search"
                    :custom-filter="filter"
                >
                  <!--                  show-group-by-->
                  <template v-slot:top>
                    <v-text-field
                        v-model="search"
                        label="Arama"
                        class="mx-4"/>
                  </template>
                  <template v-slot:item.name="{ item }">
                    <tr>
                      {{ item.name }}
                    </tr>
                  </template>
                  <template v-slot:item.lastName="{ item }">
                    <tr>
                      {{ item.lastName  }}
                    </tr>
                  </template>
                  <template v-slot:item.country="{ item }">
                    <tr>
                      {{ item.country}}
                    </tr>
                  </template>
                  <template v-slot:item.countryCode="{ item }">
                    <tr>
<!--                      {{ item.countryCode | ddMMyyyy}}-->
                      {{ item.countryCode }}
                    </tr>
                  </template>
                  <template v-slot:item.createDate="{ item }">
                    <tr>
                      {{ item.createDate | ddMMyyyy }}
                    </tr>
                  </template>
                </v-data-table>
              </v-app>
            </div>
          </div>
        </div>
<!--        <div class="row">-->
          <div class="col-lg-12 ml-2">
            <div class="row">
              <base-edit-input
                  v-model="email"
                  :rules="'required'"
                  :type="'text'"
                  :label="'Email'">
              </base-edit-input>
              <div class="input-box" style="margin-left: 10px">
                <label>-</label>
                <div class="form-group">
                  <button class="theme-btn" type="button" @click="onSendEmail()">Gönder</button>
                </div>
              </div>
            </div>
<!--          </div>-->
        </div>
    </section>
<!--            </div>-->
</div>
<!--  </div>-->
</template>

<script>
import ReservationStatus from "../component/common/ReservationStatus";
import BaseEditInput from "../component/base/BaseEditInput";
import MyAsidebar from "../component/common/MyAsidebar";
// import generalFunctions from "../util/generalFunctions";

export default {
  name: "CurrentStatusReport",
  components: {MyAsidebar, BaseEditInput, ReservationStatus},
  data () {
    return {
      sending : false,
      email: null,
      search: '',
      headers: [
        {
          align: 'start',
          text: 'İsim',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Soyisim',
          sortable: true,
          value: 'lastName'
        },
        {
          text: 'Ülke',
          sortable: true,
          value: 'country',
        },
        {
          text: 'Ülke Kodu',
          sortable: true,
          value: 'countryCode',
        },
        {
          text: 'Rezervasyon tarihi',
          sortable: true,
          value: 'createDate',
        }
      ]
    }
  },
  computed:{
    agencyReportData:{
      get(){
        let agencyReportData = this.$store.getters.getAgencyReportData;
        if(!agencyReportData) return null;

        agencyReportData.sort(function(a,b){
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.createDate) - new Date(a.createDate);
        });

        return agencyReportData;
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  methods:{
    excelFileDownload : function (){
      //TODO:Temporary id =1 (webAgency)
      let id = 1;
      window.open(this.$store.getters.getServiceUrl + "/admin-api/report/generate-agency-report/"
          +id+"?xauth="+this.$store.getters.getToken.token, '_blank').focus();

    },
    filter (value, search, item) {
      if(value == null || search == null){
        return false;
      }

      return value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
    },
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_AGENCY_RESERVATION_REPORT"]) this.$router.push("/");

    this.$store.dispatch("loadAgencyReportData");
  }
}
</script>

<style scoped>

</style>